export interface RequestOptions {
    apiUrl: string;
    method: `GET` | `POST` | `PUT`;
    endpoint: string;
    data?: any;
    headers?: Record<string, string>;
}

export const requestWithRecaptchaV3 = async (options: RequestOptions & { recaptchaV3SiteKey: string }) => {
    const recaptcha_v3_token = await window.grecaptcha.execute(options.recaptchaV3SiteKey, { action: `submit` });
    const response = await fetch(`${options.apiUrl}${options.endpoint}`, {
        method: options.method,
        body: JSON.stringify({
            recaptcha_v3_token,
            ...options.data,
        }),
        ...(options.headers && { headers: options.headers }),
    });

    return response;
};

export const request = async (options: RequestOptions) => {
    const response = await fetch(`${options.apiUrl}${options.endpoint}`, {
        method: options.method,
        ...(options.data && { body: JSON.stringify(options.data) }),
        ...(options.headers && { headers: options.headers }),
    });

    return response;
};

export const requestJson = async (options: RequestOptions) => {
    const response = await request(options);
    return response.json();
};
